import { render, staticRenderFns } from "./edit_unit.vue?vue&type=template&id=58e5b10e&"
import script from "./edit_unit.vue?vue&type=script&lang=js&"
export * from "./edit_unit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports